import { Component, EventEmitter, NgZone, OnInit, Output, ViewChild, } from '@angular/core';
import { UserService } from 'src/app/services/user.service';
import { ApiProviderService } from 'src/app/services/api-provider.service';
import { Router } from '@angular/router';
import { Formule } from 'src/app/models/formule';
import { ToastController } from '@ionic/angular';
import {
  CdkDrag,
  CdkDragDrop,
  CdkDragPlaceholder,
  CdkDropList,
  moveItemInArray,
} from '@angular/cdk/drag-drop';


@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss'],
})
export class DashboardComponent implements OnInit {


  coach: any;
  coachId: string

  widgets = [
    { id: 'next-appointment', name: 'Prochain Rendez-vous' },
    { id: 'my-client', name: 'Mes Clients' },
    { id: 'last-payments-list', name: 'Derniers Paiements' },
    { id: 'some-infos', name: 'Infos Générales' }
  ];

  private storageKey = 'dashboardWidgets';

  constructor(
    private userService: UserService,
    private ApiProviderService: ApiProviderService,
    private router: Router,
    private zone: NgZone,
    private toastr : ToastController

  ) {
  }

  ngOnInit() {
    this.coach = this.userService.getUser();
    this.loadWidgetsFromStorage();


    if (this.coach) {
      this.coachId = this.coach.id;
      this.createFirstFormule()
    } else {
    }
  }

  createFirstFormule(): void {
    this.ApiProviderService.getFormulesByCoach(this.coach.id).subscribe({
      next: (res: any) => {
        if (res.length == 0) {
          let formule = new Formule()
          formule.name = "Séance unique";
          formule.price = "50";
          formule.recurrence = "Séance";
          let register = { ...formule, IdCoach: this.coach.id }
          this.ApiProviderService.createFormule(register).subscribe({
            next: async (res: any) => {
              const toast = await this.toastr.create({
                header: 'Astuce',
                message: "Nous avons créé une formule à 50€ par séance pour vous. Les nouveaux clients seront automatiquement associés à cette formule si elle existe. Vous pouvez la modifier ou la supprimer dans l'onglet 'Formules' du menu de l'application.",
                buttons: [
                  {
                    text: 'Compris',
                    role: 'cancel'
                  }
                ]
              });
              await toast.present();
            },
            error: (error: any)=>{
              console.log(error)
            }
          })
        }
      },
      error: (error: any) => {
        console.error('An error occurred:', error);
        // Ajoutez une gestion des erreurs ici, par exemple afficher un message à l'utilisateur
      },
    });
  }

  drop(event: CdkDragDrop<any[]>) {
    moveItemInArray(this.widgets, event.previousIndex, event.currentIndex);
    this.saveWidgetsToStorage();
  }

  private saveWidgetsToStorage() {
    localStorage.setItem(this.storageKey, JSON.stringify(this.widgets));
  }

  private loadWidgetsFromStorage() {
    const savedWidgets = localStorage.getItem(this.storageKey);
    if (savedWidgets) {
      this.widgets = JSON.parse(savedWidgets);
    }
  }

    // Fonction pour obtenir la classe CSS en fonction de l'id du widget
    getWidgetClass(widget: any): string {
      switch (widget.id) {
        case 'next-appointment':
          return 'widget-next-appointment';
        case 'my-client':
          return 'widget-my-client';
        case 'last-payments-list':
          return 'widget-last-payments';
        case 'some-infos':
          return 'widget-some-infos';
        default:
          return '';
      }
    }

}
